import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions';
import {FormattedMessage} from "react-intl";
class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false,
      searchTxt: "",
      sMenu: false
    };
    this.showLogin = this.showLogin.bind(this);

  }

  showLogin() {
    this.props.dispatch(wActs.showLogin());
  }

  toggleMenu(e) {
    e.preventDefault();

    if (this.state.mobileMenuOpen) {
      //document.documentElement.classList.remove("no-scroll");
      this.setState({mobileMenuOpen: false});
    } else {
      //document.documentElement.classList.add("no-scroll");
      this.setState({mobileMenuOpen: true});
    }
  }

  handleKeyPress(event) {
    if(event.key === 'Enter'){
      event.preventDefault();
      this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
      this.handleSideMenuClick();
      //this.props.dispatch(pActs.searchProfiles(this.state.searchTxt));
      return;
    }
  }

  handleChange(event) {
    this.setState({searchTxt: event.target.value})
  }

  handleSearchButton(event) {
    event.preventDefault();
    this.props.history.push(wActs.getCultPath(this.props.WebPage,"/search?term=" + escape(this.state.searchTxt)));
    this.handleSideMenuClick();
  }

  searchProfiles() {

  }

  domainLogo() {
    let ref = this.props.ServerParams.Referer;
    if (typeof ref === "undefined") {
      ref = "https://stage.redlight.nl:3000/";
    }
    let domain = ref.replace("https://").replace("http://").split("/")[0];
    domain = domain.split(":")[0];
    domain = domain === "localhost" || domain.startsWith('10.') ? "www.redlight.nl" : domain;
    let name = "";
    let prts = domain.split(".");
    name = prts[prts.length-2];
    return ( <img src={`/imgs/${name}.svg`} alt="" /> );
  }

  handleLogout(e) {
    e.preventDefault();
    //localStorage.removeItem('siteways-bearer');
    wActs.removeCookie("auth");
    window.location.reload();
  }

  handleSideMenuClick() {
    //document.documentElement.classList.remove("no-scroll");
    this.setState({mobileMenuOpen: false});
    //window.HideSideMenu();
  }

  handleSeoClick(e) {
    e.preventDefault();
    window.open(`${this.props.WebPage.Settings.DashUrl}/seo?ref=${escape(window.location.href)}`)
    //this.props.dispatch(wActs.LoadPageSeo());
  }
  handleSettingsClick(e) {
    e.preventDefault();
    window.open(`${this.props.WebPage.Settings.DashUrl}/domain?ref=${escape(window.location.href)}`)
    //this.props.dispatch(wActs.LoadPageSeo());
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  hasRole(role) {
    let hasRole = false;
    let user = this.props.WebPage.User;
    if(!wActs.isNullOrUndefined(user.Roles) && user.Roles.length) {
      user.Roles.map((v) => {
        if(v === role) {
          hasRole = true;
        }
      })
    }
    return hasRole;
  }


  selectedLocale() {
    let loc = this.props.WebPage
  }

  getTerm() {
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com" + this.props.WebPage.ServerParams.Query;
    }
    return wActs.getParameterByName("term", url, "");
  }


  getLanguageLink(dta) {
    let smtLan = this.props.WebPage.Settings.SmartDefaultLanguage;
    //wActs.getCultPathByLang(this.props.WebPage,dta.Code);

    let loc =""; let pth = ""; let qry= "";
    if(typeof window !== "undefined") {
      localStorage.setItem(wActs.lsKey,dta.Default && smtLan ? "/" : dta.Path);
      pth = location.pathname; qry = location.search;
      loc = dta.Default && smtLan ? wActs.getLocationWithSearch("/",pth,qry) : wActs.getLocationWithSearch(wActs.stripCulturePath(dta.Path),pth,qry);
    } else {
      pth = this.props.WebPage.ServerParams.Path; qry = this.props.WebPage.ServerParams.Query;
      loc = dta.Default && smtLan ? wActs.getLocationWithSearch("/",pth,qry) : wActs.getLocationWithSearch(wActs.stripCulturePath(dta.Path),pth,qry);
    }

    if(this.props.WebPage.PageType === "homedyn" || this.props.WebPage.PageType === "home" || this.props.WebPage.PageType === "agentslist" || this.props.WebPage.PageType === "agent"  || this.props.WebPage.PageType === "profile") {
      let can = this.props.WebPage.Page.References.filter(t => {return t.HrefLang === dta.Path});
      if(typeof can[0] !== "undefined") {
        loc = can[0].Href;
      } else {
        loc = dta.Default && smtLan ? "/" : `/${dta.Path}/`;
      }
    }
    if (loc.endsWith("/") && loc !== "/") {
      loc = loc.substr(0, loc.length - 1);
    }
    if(loc.indexOf(this.props.WebPage.Settings.BlogPath)>-1) {
      loc = dta.Default && smtLan ?  `${this.props.WebPage.Settings.BlogPath}` : `/${dta.Path}${this.props.WebPage.Settings.BlogPath}`;
    }
    return loc;
  }


  handleLanguageClick(e,dta) {
    e.preventDefault();
    document.location = dta;
  }

  defaultLanguage() {
    return this.props.WebPage.Settings.DefaultLanguageCode === "undefined" ? "DUTCH" : this.props.WebPage.Settings.DefaultLanguageCode;
  }



  render() {

    //console.log("UserId", this.props.WebPage.User.UserId);
    let hLink = wActs.getCultPath(this.props.WebPage,"/");

    if(hLink.endsWith("/")) { hLink = hLink.substr(0,hLink.length -1)}

    let term = this.getTerm();
    let os = this.props.WebPage.ServerParams.UserAgent; let isMac = false;
    if(os && os.indexOf("Mac")>-1) {
      isMac=true;
    }

    return (
      <React.Fragment>
      <header className="header">
        <div className="container flex flex--between">
          <Link to={hLink} className="logo">
					<span className="ico">
						<img src="/imgs/logo.svg" alt=""/>
					</span>
            <span className={`text ${isMac ? "ios" : ""}`}>Smug<span className="blue">List</span>
					</span>
          </Link>

          <nav className="nav">

            <ul className="menu flex">
              {this.props.WebPage.Menu.Header.map((v,i) => {
                  if(v.Page) {
                    return <li key={"mnuli-1-" + i}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{wActs.capWords(v.Title)}</Link></li>;
                  } else {
                    if(v.Settings) {

                      return <li key={"mnuli-1-" + i}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} title={v.Description} target={"_blank"}>{wActs.capWords(v.Title)}</a></li>;
                    }
                  }
                  return null;
              })}
              <li>
                <a onClick={(e) => {this.setState({sMenu: !this.state.sMenu})}} style={{cursor: "pointer"}}>{wActs.getTranslation(this.props.WebPage.Translations,"dash.language")}&nbsp;&nbsp;<i className="fa fa-angle-down"/></a>
                <div className={`lang-menu ${this.state.sMenu ? "active" : ""}`}>
                  <ul>
                    {this.props.WebPage.Settings.Languages.map((v)=> {
                      return <li><a onClick={(e)=>{
                        this.setState({sMenu: false});
                        this.handleLanguageClick(e,this.getLanguageLink(v));
                      }} className="blue-link" style={{cursor: "pointer"}}><img src={`/imgs/${v.Path}.svg`}/>&nbsp;{v.Name}</a></li>
                    })}
                  </ul>
                </div>
              </li>
            </ul>

            <div className="mob-btn">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </nav>
        </div>
      </header>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams
  };
}

export default connect(mapStateToProps)(Header);
